// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/program-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/program-banner-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Programs_programs__9GI-D {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    gap: 1rem;
    box-sizing: border-box;
    font-family: 'Aktive Grotesk', sans-serif;
    color: #0A2945;
    position: relative;
}
.Programs_allPrograms__ngATg {
    border-color: #e2e8f0;
    padding: 0 11.5rem;
    padding-bottom: 2rem;
    margin-top: 1rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% auto;
}
.Programs_programsTitle__5RnV6 {
    text-align: center;
    font-family: 'Cocon Bold', sans-serif;
    font-size: 92px;
    font-weight: 500;
    margin-bottom: 0.5rem;
    padding-top: 3rem;
}
.Programs_programsTitle__5RnV6 span{
    color: #69bf4a;
}
.Programs_programsDescription__ebK0k {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-around;
    align-items: center;
    margin: 0 auto;
}
.Programs_programsList__-qr1w {
    margin: 0 auto;
    margin-bottom: 1em;
    font-size: 1.25rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.Programs_programsList__-qr1w img {
    min-width: 35px;
    height: auto;
    margin: 0.25rem 0.5rem;
}
.Programs_programsList__-qr1w div {
    display: flex;
    justify-content: left;
    align-items: flex-start;
    font-size: 42px;
    font-weight: bold;
    text-align: left;
    width: 100%;
    margin-bottom: 0.25em;
    /* box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.2); */
}
.Programs_program__lN443 {
    width: 40%;
    /* margin-bottom: 3rem; */
}
.Programs_maintenanceProgram__o8NZK {
    width: 100%;
    margin-bottom: 3rem;
}
.Programs_programTitle__nWbCa {
    font-family: 'Aktiv Grotesk';
    text-align: center;
    font-size: 45px;
    font-weight: 700;
    margin: 15px auto;
    width: 100%;
}
.Programs_programImage__hGRKZ {
    position: relative;
    height: 300px;
    z-index: 0;
}
.Programs_programText__XSiZR {
    position: relative;
}
.Programs_programDescription__apssA {
    padding-bottom: 1.5rem;
    font-size: 18px;
    padding-top: 15px;
    margin-top: 0;
    margin-left: 1rem;
    font-weight: 500;
}
.Programs_programsSubtext__CAXul {
    font-size: 14px;
    font-weight: 700;
    margin-top: 0.5rem;
    padding-bottom: 2em;
    text-align: center;
}
.Programs_programSubtext__Ek7YE {
    font-size: 14px;
    font-weight: 700;
    margin-top: 0.5rem;
    padding-left: 1em;
    padding-right: 1em;
    text-align: center;
}
.Programs_programDescription__apssA span {
    font-weight: 600;
}
.Programs_programPlans__n0Iup {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}
.Programs_maintenancePlans__TdN18 {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}
.Programs_programPlan__ov0ba {
    font-family: 'Aktiv Grotesk', sans-serif;
    font-weight: 700;
    text-align: center;
    margin: 0.5rem;
    color: #fff;
    min-width: 286px;
    cursor: pointer;
    transform: translateY(-50px) translateX(50px);
    z-index: 2;
    position: relative;
}
.Programs_maintenancePlan__qhNOL {
    display: flex;
    flex-direction: row;
}
.Programs_maintenancePlanBox__rS4qn {
    font-family: 'Aktiv Grotesk', sans-serif;
    font-weight: 700;
    text-align: center;
    margin: 0.5rem;
    color: #fff;
    min-width: 286px;
    cursor: pointer;
    /* transform: translateY(-50px) translateX(50px); */
    /* z-index: 2; */
    /* position: relative; */
}
.Programs_letsGo__cCoA3, .Programs_maintenanceLetsGo__jnjyS {
    text-align: center;
    padding: 12px;
    color: #fff;
    font-weight: bold;
    font-size: 24px;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Cocon Bold', sans-serif;
    cursor: pointer;
    margin-top: 0.5em;
}
.Programs_buttonArrow__1W1Gt {
    margin-left: 10px;
    width: 24px;
}
.Programs_semaBackground__W6iuy {
    background: #69bf4a;
}
.Programs_tirzBackground__rRj2- {
    background: #21cec9;
}
.Programs_semaPlan__MTq5b, .Programs_semaMaintenancePlan__PkBuH {
    font-size: 50px;
    display: flex;
    align-items: center;
    padding-top: 1rem;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    justify-content: center;
    border-top-left-radius: 2rem;
    border-top-right-radius: 2rem;
    background-color: #69bf4a;
    border-bottom: #69bf4a;
}
.Programs_tirzPlan__1Og51, .Programs_tirzMaintenancePlan__1Zr4V {
    font-size: 50px;
    display: flex;
    align-items: center;
    padding-top: 1rem;
    justify-content: center;
    border-top-left-radius: 2rem;
    border-top-right-radius: 2rem;
    background-color: #21cec9;
    border-bottom: #21cec9;
}
.Programs_semaPlan__MTq5b span, .Programs_tirzPlan__1Og51 span {
    margin: 0;
    font-size: 24px;
}
.Programs_semaMaintenancePlan__PkBuH span, .Programs_tirzMaintenancePlan__1Zr4V span {
    margin: 0;
    font-size: 24px;
}
.Programs_semaDescription__DprWz, .Programs_semaMaintenanceDescription__6cwiX {
    padding-bottom: 0.5rem;
    color: black;
    font-size: 18px;
    background-color: #69bf4a;
    border-bottom: #69bf4a;
} 
.Programs_tirzDescription__2GWDc, .Programs_tirzMaintenanceDescription__hzxFU {
    padding-bottom: 0.5rem;
    color: black;
    font-size: 18px;
    background-color: #21cec9;
    border-bottom: #21cec9;
}
.Programs_semaglutidePlans__NKw3b, .Programs_semaglutideMaintenancePlans__dO8KU {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 0 auto;
    color: black;
    background-color: white;
    border-left:#69bf4a 2px solid;
    border-right:#69bf4a 2px solid;
    border-bottom: #69bf4a 2px solid;
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
}
.Programs_tirzepatidePlans__9Z6eX, .Programs_tirzepatideMaintenancePlans__zIiS1 {
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
    align-items: flex-start;
    margin: 0 auto;
    color: black;
    background-color: white;
    border-left:#21cec9 2px solid;
    border-right:#21cec9 2px solid;
    border-bottom: #21cec9 2px solid;
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
}
.Programs_planButtonLeft__Yw09Z, .Programs_planButtonRight__0dzsz {
    position: absolute;
    bottom: -33px;
}
.Programs_planSubscription__VG4Ni {
    font-size: 1.25rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 2rem;
    border-bottom-right-radius: 2rem;
}
.Programs_planSubscription__VG4Ni img {
    border-radius: 2rem;
}
.Programs_planName__FAO\\+H, .Programs_maintenancePlanName__k2w-\\+ {
    font-size: 24px;
}
.Programs_planPrice__rC1b7, .Programs_maintenancePlanPrice__9LrCT {
    font-family: 'Cocon Bold';
    font-size: 60px;
    font-weight: 700;
    border-radius: 2rem;

    span {
        font-size: 40px;
    }
}
.Programs_priceSubtext__MxlVj {
    font-size: 16px;
}
.Programs_programBanner__fGffS {
    display: flex;
    justify-content: space-between;
    align-items: end;
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    background-position: center;
    justify-content: center;
    align-items: bottom;
    height: 250px;
    margin-bottom: 2em;
}
.Programs_programDivider__LoFzj {
    height: 10px;
    width: 90%;
    margin-left: 90px;
    margin-right: 90px;
    background-color: #69bf4a;
    position: absolute;
    bottom: -5px;
    border-radius: 999px;
}
.Programs_programsDivider__nxMcO {
    width: 100%;
    margin-top: 68px;
    height: 7px;
}
.Programs_bannerText__5q\\+k- {
    padding: 0 0 0 5%;
    min-width: 400px;
}
.Programs_bannerSubtitle__0kFn- {
    font-size: 26px;
    font-weight: 700;
    margin: 0;
    padding-left: 5px;
}
.Programs_bannerTitle__gNFyP {
    font-size: 100px;
    font-family: 'Cocon Bold', sans-serif;
    padding-bottom: 10px;
}
.Programs_goToMaintenance__vGA4l {
    font-family: 'Aktive Grotesk', sans-serif;
    font-size: 24px;
    font-weight: 800;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 75%;
    text-align: center;
    margin: 0 auto;
    padding-top: 0.25em;
    padding-bottom: 1em;
}
.Programs_buttonLabel__D2zky {
    font-weight: 800;
    font-size: 25px;
}
.Programs_tirzHeading__TVTwk {
    color: #fff;
    padding: 3px;
    border-radius: 999px;
    position: relative;
    background-color: #21cec9;
    border-bottom: #21cec9;
}
.Programs_semaHeading__OgWzs {
    color: #fff;
    padding: 3px;
    border-radius: 999px;
    position: relative;
    background-color: #69bf4a;
    border-bottom: #69bf4a;
}
.Programs_programButtons__1pumR {
    display: none;
}

.Programs_journeyBtn2__Wy6\\+h {
    background-color: #69bf4a;
    width: 50%;
    text-align: center;
    padding: 12px;
    color: #fff;
    font-size: 36px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;
    font-family: 'Cocon Bold', sans-serif;
    margin: 0 auto;
    cursor: pointer;
}
.Programs_journeyArrow__-29XB {
    width: 40px;
}
.Programs_orImg__ZSwyR{
    height: 180px;
}
.Programs_programBorder__abxYT {
    display: block;
    margin: 0px auto;
    width: 75%;
    position: relative;
    top: 28px;
}
.Programs_responsiveProgram__CORoS {
    display: flex;
    align-Items: center;
    justify-content: space-between;
}
.Programs_checkmark__4gvef {
    height: 90px;
}
.Programs_splitter__0Gh2I{
    height: 50%;
}
.Programs_programPanel__qWlRd {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}
.Programs_planButtonLeft__Yw09Z, .Programs_planButtonRight__0dzsz {
    position: absolute;
    bottom: -33px;
}
.Programs_checkoutSelect__AO3NS {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 20px;
}
.Programs_glowGreen__InM8B {
    box-shadow: 0 0 30px #00ff00;
}
.Programs_glowBlue__vPXaO {
    box-shadow: 0 0 30px #00ffff;
}
.Programs_higherDoses__IUCxU {
    font-family: 'Aktiv Grotesk', sans-serif;
    font-size: 16px;
    color: #808080;
    font-weight: 500;
    text-align: center;
    width: 100%;
    margin-top: 0.5em;
}

@media screen and (max-width: 1700px) {
    .Programs_programTitle__nWbCa {
        margin: 5px auto;
    }
    .Programs_programPanel__qWlRd {
        align-items: flex-start;
    }
    .Programs_programImage__hGRKZ {
        height: 250px;
    
    }
    .Programs_programPlans__n0Iup {
        justify-content: center;
    }
    .Programs_semaPlan__MTq5b, .Programs_tirzPlan__1Og51 {
        padding-top: 0.25rem;
        font-size: 30px;
    }
    .Programs_semaDescription__DprWz, .Programs_tirzDescription__2GWDc {
        font-size: 14px;
    }
    .Programs_planSubscription__VG4Ni {
        margin-top: 0;
        min-height: 0;
        padding: 0.5rem;
    }
    .Programs_planName__FAO\\+H {
        font-size: 16px;
    }
    .Programs_planPrice__rC1b7 {
        font-size: 28px;

        span {
            font-size: 18px;
        }
    }
    .Programs_programPlan__ov0ba {
        min-width: 220px;
    }
    .Programs_planPrice__rC1b7 {
        font-size: 40px;

        span {
            font-size: 32px;
        }
    }
    .Programs_letsGo__cCoA3 {
        margin-top: 0;
        font-size: 20px;
        padding: 8px;
    }
    .Programs_goToMaintenance__vGA4l {
        font-size: 20px;
    }
    .Programs_programDescription__apssA {
        font-size: 14px;
        padding-bottom: 0;
    }
}
@media screen and (max-width: 1369px) {
    .Programs_programsTitle__5RnV6 {
        font-size: 60px;
    }
    .Programs_orImg__ZSwyR {
        height: 150px;
    }
    .Programs_bannerTitle__gNFyP {
        font-size: 80px;
    }
    .Programs_bannerSubtitle__0kFn- {
        font-size: 24px;
    }
    .Programs_programTitle__nWbCa {
        font-size: 40px;
    }
    .Programs_higherDoses__IUCxU {
        font-size: 14px;
    }
    .Programs_programPlan__ov0ba {
        min-width: 180px;
    }
    .Programs_semaPlan__MTq5b, .Programs_tirzPlan__1Og51 {
        font-size: 26px ;
    }
    .Programs_semaDescription__DprWz, .Programs_tirzDescription__2GWDc {
        font-size: 12px ;
    }
    .Programs_planButtonLeft__Yw09Z, .Programs_planButtonRight__0dzsz {
        bottom: -25px;
        width: 150px;
    }
    .Programs_programsList__-qr1w img {
        min-width: 30px;
    }
    .Programs_programsList__-qr1w div {
        font-size: 32px;
    }
    .Programs_allPrograms__ngATg {
        background-size: cover;
    }
    .Programs_journeyBtn2__Wy6\\+h {
        width: 52%;
        font-size: 20px;
    }
    .Programs_programsDivider__nxMcO {
        margin-bottom: 20px;
    }
}
@media screen and (max-width: 1160px) {
    .Programs_programBanner__fGffS {
        height: 180px;
    }
    .Programs_program__lN443 {
        margin-bottom: 10px;
    }
    .Programs_programBorder__abxYT {
        top: 20px;
    }
    .Programs_orImg__ZSwyR{
        height: 110px;
    }
    .Programs_programDescription__apssA {
        font-size: 16px;
    }
    .Programs_higherDoses__IUCxU {
        font-size: 16px;
    }
    .Programs_programPlan__ov0ba {
        transform: translateY(0px) translateX(20px);
    }
    .Programs_bannerTitle__gNFyP {
        font-size: 60px;
    }
    .Programs_bannerSubtitle__0kFn- {
        font-size: 20px;
    }
    .Programs_programsTitle__5RnV6 {
        font-size: 50px ;
    }
    .Programs_planButtonLeft__Yw09Z, .Programs_planButtonRight__0dzsz {
        bottom: -20px;
        width: 115px;
        margin-left: 25px;
        margin-right: 25px;
    }
    .Programs_programsDivider__nxMcO {
        margin-top: 25px;
    }
    .Programs_programImage__hGRKZ {
        height: 200px;
    }
    .Programs_goToMaintenance__vGA4l {
        font-size: 18px;
    }
}

@media screen and (max-width: 1035px) {
    .Programs_programBanner__fGffS {
        height: 140px;
    }
    .Programs_bannerSubtitle__0kFn- {
        font-size: 18px;
    }
    .Programs_journeyBtn2__Wy6\\+h {
        width: 80%;
        font-size: 18px;
    }
    .Programs_boderline__X8Oe1 {
        width: 100% ;
    }
    .Programs_programs__9GI-D {
        width: 98%;
    }
    .Programs_programButtons__1pumR {
        display: flex;
        flex-direction: row;
        margin: 0 auto;
        align-items: center;
        justify-content: space-evenly;        
    }
    .Programs_programButtons__1pumR button {
        position: relative;
        background: #fff;
        padding: 0px 10px 0px 10px;
        margin: 0 5px;
        border-radius: 14px;
        font-size: 17px;
        font-weight: 500;
        color: #fff;
        cursor: pointer;
        border: 2px solid transparent;
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 60px;
        z-index: 1;
    }
    .Programs_programButtons__1pumR a {
        text-decoration: none;
    }
    .Programs_checkmark__4gvef {
        height: 25px ;
    }
    .Programs_programPanel__qWlRd {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
    }
    .Programs_planSubscription__VG4Ni{
        margin-top: 0 ;
        margin: 0 auto;
        width: 98%;
    }
    .Programs_programImage__hGRKZ {
        height: 180px;
    }
    .Programs_responsiveProgram__CORoS {
        flex-direction: column;
        text-align: center;
    }
    .Programs_bannerText__5q\\+k- {
        min-width: 0;
        margin: 0 auto;
        padding: 0;
        text-align: center;
        line-height: 1;
    }
    .Programs_bannerTitle__gNFyP {
        font-size: 40px;
    }
    .Programs_programsDivider__nxMcO {
        margin-top: 0px;
        margin-bottom: 0px;
    }
    .Programs_allPrograms__ngATg {
        padding: 0 7rem;
    }
    .Programs_program__lN443 {
        width: 45%;
    }
    .Programs_programsList__-qr1w {
        font-size: 0.75rem;
        margin-left: 20px;
        margin-right: 20px;
    }
    .Programs_programsList__-qr1w img {
        min-width: 20px;
        margin: 0.25rem 0.5rem;
    }
    .Programs_programsList__-qr1w div {
        font-size: 24px ;
    }
    .Programs_programDescription__apssA {
        padding-top: 0.5em;
        font-size: 12px;
    }
    .Programs_programPlan__ov0ba {
        transform: translateY(-30px) translateX(20px);
    }
    .Programs_higherDoses__IUCxU {
        font-size: 12px;
    }
    .Programs_programTitle__nWbCa {
        font-size: 32px;
    }
    .Programs_programSubtext__Ek7YE {
        margin-top: 0.25rem;
        font-size: 10px;
    }
    .Programs_semaDescription__DprWz, .Programs_tirzDescription__2GWDc {
        font-size: 14px;
    }
    .Programs_planPrice__rC1b7 {
        font-size: 36px;

        span {
            font-size: 24px;
        }
    }
    .Programs_priceSubtext__MxlVj {
        font-size: 12px;
    }
    .Programs_planName__FAO\\+H {
        font-size: 14px;
    }
    .Programs_semaPlan__MTq5b, .Programs_tirzPlan__1Og51 {
        font-size: 22px ;
    }
    .Programs_planButtonLeft__Yw09Z, .Programs_planButtonRight__0dzsz {
        display: flex;
        position: absolute;
        bottom: -22px;
        width: 115px;
        padding-left: 15px;
        padding-right: 15px;
    }
    .Programs_planButtonLeft__Yw09Z {
        margin-right: 0px;
        padding-right: 0px;
    }
    .Programs_planButtonRight__0dzsz {
        margin-left: 0px;
        padding-left: 0px;
    }
    .Programs_orImg__ZSwyR{
        height: 110px;
    }
    .Programs_programsTitle__5RnV6 {
        padding-top: 0.5em;
        font-size: 26px;
    }
    .Programs_semaPlan__MTq5b span, .Programs_tirzPlan__1Og51 span {
        font-size: 16px ;
    }
    .Programs_programDivider__LoFzj {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        height: 10px;
        border-radius: 0;
    }
    .Programs_buttonLabel__D2zky {
        font-size: 20px;
    }
    .Programs_goToMaintenance__vGA4l {
        width: 90%;
        font-size: 16px;
    }
}

@media screen and (max-width: 878px) {
    /* .program {
        width: 80%;
    } */
    .Programs_bannerTitle__gNFyP {
        font-size: 30px;
    }
    .Programs_bannerText__5q\\+k- h2 {
        font-size: 51px;
        margin: 0px 0px 20px;
    }
    .Programs_maintenancePlanBox__rS4qn {
        min-width: 170px;
    }
    .Programs_programPlan__ov0ba {
        min-width: 170px;
        transform: translateY(-20px) translateX(0px);
    }
    .Programs_semaPlan__MTq5b, .Programs_tirzPlan__1Og51, .Programs_semaMaintenancePlan__PkBuH, .Programs_tirzMaintenancePlan__1Zr4V {
        font-size: 22px;
    }
    .Programs_semaDescription__DprWz, .Programs_tirzDescription__2GWDc, .Programs_semaMaintenanceDescription__6cwiX, .Programs_tirzMaintenanceDescription__hzxFU {
        font-size: 10px;
    }
    .Programs_maintenancePlanPrice__9LrCT {
        font-size: 40px;
    }
    .Programs_maintenancePlanName__k2w-\\+ {
        font-size: 16px;
    }
    .Programs_letsGo__cCoA3, .Programs_maintenanceLetsGo__jnjyS {
        font-size: 18px;
        padding: 7px;
        gap: 0;
    }
}

@media screen and (max-width: 800px) {
    .Programs_programBanner__fGffS {
        margin-bottom: 0.5em;
    }
    .Programs_checkoutSelect__AO3NS {
        font-size: 24px;
    }
    .Programs_programPlan__ov0ba {
        min-width: 150px;
        transform: translateY(0px) translateX(0px);
    }
    .Programs_programDescription__apssA {
        font-size: 11px;
    }
    .Programs_programImage__hGRKZ {
        height: 140px;
    }
    .Programs_buttonArrow__1W1Gt {
        width: 15px;
    }
    .Programs_planPrice__rC1b7 {
        font-size: 28px;
    }
    .Programs_programsDivider__nxMcO {
        margin-top: 20px;
        margin-bottom: 20px;
        height: 4px;
    }
    .Programs_orImg__ZSwyR{
        height: 100px;
    }
    .Programs_allPrograms__ngATg {
        padding-left: 5%;
        padding-right: 5%;
        padding-bottom: 5em;
    }
    .Programs_programsList__-qr1w div {
        font-size: 20px;
    }
    .Programs_programsList__-qr1w img {
        min-width: 15px;
    }
    .Programs_goToMaintenance__vGA4l {
        font-size: 14px;
    }
}

@media screen and (max-width: 740px) {
    .Programs_program__lN443 {
        width: 90%;
    }
    .Programs_programPlan__ov0ba {
        min-width: 200px;
        transform: translateY(-10px) translateX(40px);
    }
    .Programs_programImage__hGRKZ {
        height: 130px;
    }
    .Programs_programSubtext__Ek7YE {
        font-size: 10px;
    }
}

@media screen and (max-width: 518px) {
    .Programs_programTitle__nWbCa {
        font-size: 32px;
        margin: 0;
    }
    .Programs_semaPlan__MTq5b, .Programs_tirzPlan__1Og51 {
        padding-top: 0.25rem;
    }
    .Programs_programPlan__ov0ba {
        min-width: 170px;
        transform: translateY(-10px) translateX(40px);
    }
    .Programs_programSubtext__Ek7YE {
        margin-top: 0.25rem;
    }
    .Programs_planSubscription__VG4Ni {
        padding: 0.5rem;
        min-width: 0;
    }
    .Programs_letsGo__cCoA3 {
        font-size: 16px;
        padding: 8px;
    }
    .Programs_semaDescription__DprWz, .Programs_tirzDescription__2GWDc {
        font-size: 10px;
    }
    .Programs_programImage__hGRKZ {
        height: 150px;
    }
    .Programs_programDescription__apssA {
        padding-left: 0.5em;
        padding-top: 0.5em;
    }
    .Programs_programsList__-qr1w div {
        font-size: 16px;
    }
    .Programs_programsList__-qr1w img {
        min-width: 20px;
    }
    .Programs_allPrograms__ngATg {
        padding-left: 1em;
        padding-right: 1em;
    }
    .Programs_goToMaintenance__vGA4l {
        font-size: 12px;
    }
}

@media screen and (max-width: 444px) {
    .Programs_program__lN443 {
        width: 98%;
    }
    .Programs_programImage__hGRKZ {
        height: 120px;
    }
    .Programs_programPlan__ov0ba {
        min-width: 150px;
        transform: translateY(-10px) translateX(20px);
    }
    .Programs_programTitle__nWbCa {
        font-size: 28px;
    }
    .Programs_programSubtext__Ek7YE {
        font-size: 10px;
    }
    .Programs_programDescription__apssA {
        padding-top: 0.5em;
        padding-bottom: 0.5em;
        font-size: 10px;
    }
    .Programs_higherDoses__IUCxU {
        font-size: 10px;
    }
    .Programs_planSubscription__VG4Ni {
        min-width: 0;    
    }
    .Programs_buttonLabel__D2zky {
        font-size: 16px;
    }
    .Programs_bannerSubtitle__0kFn- {
        font-size: 12px;
    }
    .Programs_planPrice__rC1b7 {
        font-size: 20px;
    }
    .Programs_planName__FAO\\+H {
        font-size: 12px;
    }
    .Programs_programsList__-qr1w div {
        font-size: 14px;    
    }
    .Programs_programsList__-qr1w img {
        min-width: 15px;
    }
}
@media screen and (max-width: 378px) {
    .Programs_programPlan__ov0ba {
        transform: translateY(0px) translateX(10px);
    }
    .Programs_programsList__-qr1w {
        margin-left: 0;
        margin-right: 0;
    }
    .Programs_programsTitle__5RnV6 {
        font-size: 22px;
    }
    .Programs_goToMaintenance__vGA4l {
        font-size: 10px;
    }
}
@media screen and (max-width: 323px) {
    .Programs_programTitle__nWbCa {
        font-size: 24px;
    }
    .Programs_programBanner__fGffS {
        height: 100px;
    }
    .Programs_bannerTitle__gNFyP {
        font-size: 24px;
    }
    .Programs_checkoutSelect__AO3NS {
        font-size: 18px;
        margin-bottom: 5px;
    }
    .Programs_programDivider__LoFzj {
        height: 6px;
    }
    .Programs_programPlans__n0Iup {
        width: 98%;
    }
    .Programs_semaPlan__MTq5b, .Programs_tirzPlan__1Og51 {
        font-size: 18px;
    }
    .Programs_programPlan__ov0ba {
        margin: 0.25em;
        /* min-width: 0px; */
        transform: translateY(00px) translateX(0px);
    }
    .Programs_buttonLabel__D2zky {
        font-size: 14px;
    }
    .Programs_programButtons__1pumR button {
        font-size: 12px;
        height: 50px;
    }
    .Programs_letsGo__cCoA3 {
        font-size: 14px;
        padding: 6px;
    }
    .Programs_buttonArrow__1W1Gt {
        width: 16px;
    }
    .Programs_programsTitle__5RnV6 {
        font-size: 20px;
    }
    .Programs_programsList__-qr1w div {
        font-size: 12px;
    }
    .Programs_programsList__-qr1w img {
        width: 12px;
        min-width: 12px;
    }
    .Programs_journeyBtn2__Wy6\\+h {
        font-size: 14px;
    }
    .Programs_journeyArrow__-29XB {
        width: 30px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Programs/Programs.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,yCAAyC;IACzC,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,yDAAkD;IAClD,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,YAAY;IACZ,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,sDAAsD;AAC1D;AACA;IACI,UAAU;IACV,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,mDAAmD;IACnD,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,SAAS;IACT,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;IAChC,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;IAChC,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;;IAEnB;QACI,eAAe;IACnB;AACJ;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,yDAAwD;IACxD,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,qCAAqC;IACrC,oBAAoB;AACxB;AACA;IACI,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,qCAAqC;IACrC,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,wCAAwC;IACxC,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,aAAa;;IAEjB;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,oBAAoB;QACpB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,aAAa;QACb,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;;QAEf;YACI,eAAe;QACnB;IACJ;IACA;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;;QAEf;YACI,eAAe;QACnB;IACJ;IACA;QACI,aAAa;QACb,eAAe;QACf,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,SAAS;IACb;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,2CAA2C;IAC/C;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,UAAU;IACd;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,mBAAmB;QACnB,6BAA6B;IACjC;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,0BAA0B;QAC1B,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,6BAA6B;QAC7B,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,YAAY;QACZ,UAAU;IACd;IACA;QACI,qBAAqB;IACzB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,2BAA2B;IAC/B;IACA;QACI,cAAc;QACd,cAAc;QACd,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,YAAY;QACZ,cAAc;QACd,UAAU;QACV,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,6CAA6C;IACjD;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;;QAEf;YACI,eAAe;QACnB;IACJ;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;IACvB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,aAAa;IACjB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,cAAc;QACd,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;IACI;;OAEG;IACH;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,gBAAgB;QAChB,4CAA4C;IAChD;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,YAAY;QACZ,MAAM;IACV;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,0CAA0C;IAC9C;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;QAChB,mBAAmB;QACnB,WAAW;IACf;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,gBAAgB;QAChB,6CAA6C;IACjD;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,SAAS;IACb;IACA;QACI,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,6CAA6C;IACjD;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;IACA;QACI,gBAAgB;QAChB,6CAA6C;IACjD;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,qBAAqB;QACrB,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,2CAA2C;IAC/C;IACA;QACI,cAAc;QACd,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,kBAAkB;IACtB;IACA;QACI,WAAW;IACf;IACA;QACI,UAAU;IACd;IACA;QACI,eAAe;IACnB;IACA;QACI,cAAc;QACd,oBAAoB;QACpB,2CAA2C;IAC/C;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":[".programs {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    width: 100%;\n    gap: 1rem;\n    box-sizing: border-box;\n    font-family: 'Aktive Grotesk', sans-serif;\n    color: #0A2945;\n    position: relative;\n}\n.allPrograms {\n    border-color: #e2e8f0;\n    padding: 0 11.5rem;\n    padding-bottom: 2rem;\n    margin-top: 1rem;\n    background-image: url(../../assets/program-bg.png);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 100% auto;\n}\n.programsTitle {\n    text-align: center;\n    font-family: 'Cocon Bold', sans-serif;\n    font-size: 92px;\n    font-weight: 500;\n    margin-bottom: 0.5rem;\n    padding-top: 3rem;\n}\n.programsTitle span{\n    color: #69bf4a;\n}\n.programsDescription {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-around;\n    align-items: center;\n    margin: 0 auto;\n}\n.programsList {\n    margin: 0 auto;\n    margin-bottom: 1em;\n    font-size: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n.programsList img {\n    min-width: 35px;\n    height: auto;\n    margin: 0.25rem 0.5rem;\n}\n.programsList div {\n    display: flex;\n    justify-content: left;\n    align-items: flex-start;\n    font-size: 42px;\n    font-weight: bold;\n    text-align: left;\n    width: 100%;\n    margin-bottom: 0.25em;\n    /* box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.2); */\n}\n.program {\n    width: 40%;\n    /* margin-bottom: 3rem; */\n}\n.maintenanceProgram {\n    width: 100%;\n    margin-bottom: 3rem;\n}\n.programTitle {\n    font-family: 'Aktiv Grotesk';\n    text-align: center;\n    font-size: 45px;\n    font-weight: 700;\n    margin: 15px auto;\n    width: 100%;\n}\n.programImage {\n    position: relative;\n    height: 300px;\n    z-index: 0;\n}\n.programText {\n    position: relative;\n}\n.programDescription {\n    padding-bottom: 1.5rem;\n    font-size: 18px;\n    padding-top: 15px;\n    margin-top: 0;\n    margin-left: 1rem;\n    font-weight: 500;\n}\n.programsSubtext {\n    font-size: 14px;\n    font-weight: 700;\n    margin-top: 0.5rem;\n    padding-bottom: 2em;\n    text-align: center;\n}\n.programSubtext {\n    font-size: 14px;\n    font-weight: 700;\n    margin-top: 0.5rem;\n    padding-left: 1em;\n    padding-right: 1em;\n    text-align: center;\n}\n.programDescription span {\n    font-weight: 600;\n}\n.programPlans {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-evenly;\n}\n.maintenancePlans {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.programPlan {\n    font-family: 'Aktiv Grotesk', sans-serif;\n    font-weight: 700;\n    text-align: center;\n    margin: 0.5rem;\n    color: #fff;\n    min-width: 286px;\n    cursor: pointer;\n    transform: translateY(-50px) translateX(50px);\n    z-index: 2;\n    position: relative;\n}\n.maintenancePlan {\n    display: flex;\n    flex-direction: row;\n}\n.maintenancePlanBox {\n    font-family: 'Aktiv Grotesk', sans-serif;\n    font-weight: 700;\n    text-align: center;\n    margin: 0.5rem;\n    color: #fff;\n    min-width: 286px;\n    cursor: pointer;\n    /* transform: translateY(-50px) translateX(50px); */\n    /* z-index: 2; */\n    /* position: relative; */\n}\n.letsGo, .maintenanceLetsGo {\n    text-align: center;\n    padding: 12px;\n    color: #fff;\n    font-weight: bold;\n    font-size: 24px;\n    border-radius: 25px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: 'Cocon Bold', sans-serif;\n    cursor: pointer;\n    margin-top: 0.5em;\n}\n.buttonArrow {\n    margin-left: 10px;\n    width: 24px;\n}\n.semaBackground {\n    background: #69bf4a;\n}\n.tirzBackground {\n    background: #21cec9;\n}\n.semaPlan, .semaMaintenancePlan {\n    font-size: 50px;\n    display: flex;\n    align-items: center;\n    padding-top: 1rem;\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n    justify-content: center;\n    border-top-left-radius: 2rem;\n    border-top-right-radius: 2rem;\n    background-color: #69bf4a;\n    border-bottom: #69bf4a;\n}\n.tirzPlan, .tirzMaintenancePlan {\n    font-size: 50px;\n    display: flex;\n    align-items: center;\n    padding-top: 1rem;\n    justify-content: center;\n    border-top-left-radius: 2rem;\n    border-top-right-radius: 2rem;\n    background-color: #21cec9;\n    border-bottom: #21cec9;\n}\n.semaPlan span, .tirzPlan span {\n    margin: 0;\n    font-size: 24px;\n}\n.semaMaintenancePlan span, .tirzMaintenancePlan span {\n    margin: 0;\n    font-size: 24px;\n}\n.semaDescription, .semaMaintenanceDescription {\n    padding-bottom: 0.5rem;\n    color: black;\n    font-size: 18px;\n    background-color: #69bf4a;\n    border-bottom: #69bf4a;\n} \n.tirzDescription, .tirzMaintenanceDescription {\n    padding-bottom: 0.5rem;\n    color: black;\n    font-size: 18px;\n    background-color: #21cec9;\n    border-bottom: #21cec9;\n}\n.semaglutidePlans, .semaglutideMaintenancePlans {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-evenly;\n    align-items: flex-start;\n    margin: 0 auto;\n    color: black;\n    background-color: white;\n    border-left:#69bf4a 2px solid;\n    border-right:#69bf4a 2px solid;\n    border-bottom: #69bf4a 2px solid;\n    border-bottom-left-radius: 2rem;\n    border-bottom-right-radius: 2rem;\n}\n.tirzepatidePlans, .tirzepatideMaintenancePlans {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-evenly;\n    align-items: flex-start;\n    margin: 0 auto;\n    color: black;\n    background-color: white;\n    border-left:#21cec9 2px solid;\n    border-right:#21cec9 2px solid;\n    border-bottom: #21cec9 2px solid;\n    border-bottom-left-radius: 2rem;\n    border-bottom-right-radius: 2rem;\n}\n.planButtonLeft, .planButtonRight {\n    position: absolute;\n    bottom: -33px;\n}\n.planSubscription {\n    font-size: 1.25rem;\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    border-bottom-left-radius: 2rem;\n    border-bottom-right-radius: 2rem;\n}\n.planSubscription img {\n    border-radius: 2rem;\n}\n.planName, .maintenancePlanName {\n    font-size: 24px;\n}\n.planPrice, .maintenancePlanPrice {\n    font-family: 'Cocon Bold';\n    font-size: 60px;\n    font-weight: 700;\n    border-radius: 2rem;\n\n    span {\n        font-size: 40px;\n    }\n}\n.priceSubtext {\n    font-size: 16px;\n}\n.programBanner {\n    display: flex;\n    justify-content: space-between;\n    align-items: end;\n    position: relative;\n    background-image: url(../../assets/program-banner-2.png);\n    background-size: cover;\n    background-position: center;\n    justify-content: center;\n    align-items: bottom;\n    height: 250px;\n    margin-bottom: 2em;\n}\n.programDivider {\n    height: 10px;\n    width: 90%;\n    margin-left: 90px;\n    margin-right: 90px;\n    background-color: #69bf4a;\n    position: absolute;\n    bottom: -5px;\n    border-radius: 999px;\n}\n.programsDivider {\n    width: 100%;\n    margin-top: 68px;\n    height: 7px;\n}\n.bannerText {\n    padding: 0 0 0 5%;\n    min-width: 400px;\n}\n.bannerSubtitle {\n    font-size: 26px;\n    font-weight: 700;\n    margin: 0;\n    padding-left: 5px;\n}\n.bannerTitle {\n    font-size: 100px;\n    font-family: 'Cocon Bold', sans-serif;\n    padding-bottom: 10px;\n}\n.goToMaintenance {\n    font-family: 'Aktive Grotesk', sans-serif;\n    font-size: 24px;\n    font-weight: 800;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 75%;\n    text-align: center;\n    margin: 0 auto;\n    padding-top: 0.25em;\n    padding-bottom: 1em;\n}\n.buttonLabel {\n    font-weight: 800;\n    font-size: 25px;\n}\n.tirzHeading {\n    color: #fff;\n    padding: 3px;\n    border-radius: 999px;\n    position: relative;\n    background-color: #21cec9;\n    border-bottom: #21cec9;\n}\n.semaHeading {\n    color: #fff;\n    padding: 3px;\n    border-radius: 999px;\n    position: relative;\n    background-color: #69bf4a;\n    border-bottom: #69bf4a;\n}\n.programButtons {\n    display: none;\n}\n\n.journeyBtn2 {\n    background-color: #69bf4a;\n    width: 50%;\n    text-align: center;\n    padding: 12px;\n    color: #fff;\n    font-size: 36px;\n    border-radius: 999px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    justify-content: center;\n    font-family: 'Cocon Bold', sans-serif;\n    margin: 0 auto;\n    cursor: pointer;\n}\n.journeyArrow {\n    width: 40px;\n}\n.orImg{\n    height: 180px;\n}\n.programBorder {\n    display: block;\n    margin: 0px auto;\n    width: 75%;\n    position: relative;\n    top: 28px;\n}\n.responsiveProgram {\n    display: flex;\n    align-Items: center;\n    justify-content: space-between;\n}\n.checkmark {\n    height: 90px;\n}\n.splitter{\n    height: 50%;\n}\n.programPanel {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n}\n.planButtonLeft, .planButtonRight {\n    position: absolute;\n    bottom: -33px;\n}\n.checkoutSelect {\n    font-size: 28px;\n    font-weight: 700;\n    margin-bottom: 20px;\n}\n.glowGreen {\n    box-shadow: 0 0 30px #00ff00;\n}\n.glowBlue {\n    box-shadow: 0 0 30px #00ffff;\n}\n.higherDoses {\n    font-family: 'Aktiv Grotesk', sans-serif;\n    font-size: 16px;\n    color: #808080;\n    font-weight: 500;\n    text-align: center;\n    width: 100%;\n    margin-top: 0.5em;\n}\n\n@media screen and (max-width: 1700px) {\n    .programTitle {\n        margin: 5px auto;\n    }\n    .programPanel {\n        align-items: flex-start;\n    }\n    .programImage {\n        height: 250px;\n    \n    }\n    .programPlans {\n        justify-content: center;\n    }\n    .semaPlan, .tirzPlan {\n        padding-top: 0.25rem;\n        font-size: 30px;\n    }\n    .semaDescription, .tirzDescription {\n        font-size: 14px;\n    }\n    .planSubscription {\n        margin-top: 0;\n        min-height: 0;\n        padding: 0.5rem;\n    }\n    .planName {\n        font-size: 16px;\n    }\n    .planPrice {\n        font-size: 28px;\n\n        span {\n            font-size: 18px;\n        }\n    }\n    .programPlan {\n        min-width: 220px;\n    }\n    .planPrice {\n        font-size: 40px;\n\n        span {\n            font-size: 32px;\n        }\n    }\n    .letsGo {\n        margin-top: 0;\n        font-size: 20px;\n        padding: 8px;\n    }\n    .goToMaintenance {\n        font-size: 20px;\n    }\n    .programDescription {\n        font-size: 14px;\n        padding-bottom: 0;\n    }\n}\n@media screen and (max-width: 1369px) {\n    .programsTitle {\n        font-size: 60px;\n    }\n    .orImg {\n        height: 150px;\n    }\n    .bannerTitle {\n        font-size: 80px;\n    }\n    .bannerSubtitle {\n        font-size: 24px;\n    }\n    .programTitle {\n        font-size: 40px;\n    }\n    .higherDoses {\n        font-size: 14px;\n    }\n    .programPlan {\n        min-width: 180px;\n    }\n    .semaPlan, .tirzPlan {\n        font-size: 26px ;\n    }\n    .semaDescription, .tirzDescription {\n        font-size: 12px ;\n    }\n    .planButtonLeft, .planButtonRight {\n        bottom: -25px;\n        width: 150px;\n    }\n    .programsList img {\n        min-width: 30px;\n    }\n    .programsList div {\n        font-size: 32px;\n    }\n    .allPrograms {\n        background-size: cover;\n    }\n    .journeyBtn2 {\n        width: 52%;\n        font-size: 20px;\n    }\n    .programsDivider {\n        margin-bottom: 20px;\n    }\n}\n@media screen and (max-width: 1160px) {\n    .programBanner {\n        height: 180px;\n    }\n    .program {\n        margin-bottom: 10px;\n    }\n    .programBorder {\n        top: 20px;\n    }\n    .orImg{\n        height: 110px;\n    }\n    .programDescription {\n        font-size: 16px;\n    }\n    .higherDoses {\n        font-size: 16px;\n    }\n    .programPlan {\n        transform: translateY(0px) translateX(20px);\n    }\n    .bannerTitle {\n        font-size: 60px;\n    }\n    .bannerSubtitle {\n        font-size: 20px;\n    }\n    .programsTitle {\n        font-size: 50px ;\n    }\n    .planButtonLeft, .planButtonRight {\n        bottom: -20px;\n        width: 115px;\n        margin-left: 25px;\n        margin-right: 25px;\n    }\n    .programsDivider {\n        margin-top: 25px;\n    }\n    .programImage {\n        height: 200px;\n    }\n    .goToMaintenance {\n        font-size: 18px;\n    }\n}\n\n@media screen and (max-width: 1035px) {\n    .programBanner {\n        height: 140px;\n    }\n    .bannerSubtitle {\n        font-size: 18px;\n    }\n    .journeyBtn2 {\n        width: 80%;\n        font-size: 18px;\n    }\n    .boderline {\n        width: 100% ;\n    }\n    .programs {\n        width: 98%;\n    }\n    .programButtons {\n        display: flex;\n        flex-direction: row;\n        margin: 0 auto;\n        align-items: center;\n        justify-content: space-evenly;        \n    }\n    .programButtons button {\n        position: relative;\n        background: #fff;\n        padding: 0px 10px 0px 10px;\n        margin: 0 5px;\n        border-radius: 14px;\n        font-size: 17px;\n        font-weight: 500;\n        color: #fff;\n        cursor: pointer;\n        border: 2px solid transparent;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        height: 60px;\n        z-index: 1;\n    }\n    .programButtons a {\n        text-decoration: none;\n    }\n    .checkmark {\n        height: 25px ;\n    }\n    .programPanel {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-start;\n    }\n    .planSubscription{\n        margin-top: 0 ;\n        margin: 0 auto;\n        width: 98%;\n    }\n    .programImage {\n        height: 180px;\n    }\n    .responsiveProgram {\n        flex-direction: column;\n        text-align: center;\n    }\n    .bannerText {\n        min-width: 0;\n        margin: 0 auto;\n        padding: 0;\n        text-align: center;\n        line-height: 1;\n    }\n    .bannerTitle {\n        font-size: 40px;\n    }\n    .programsDivider {\n        margin-top: 0px;\n        margin-bottom: 0px;\n    }\n    .allPrograms {\n        padding: 0 7rem;\n    }\n    .program {\n        width: 45%;\n    }\n    .programsList {\n        font-size: 0.75rem;\n        margin-left: 20px;\n        margin-right: 20px;\n    }\n    .programsList img {\n        min-width: 20px;\n        margin: 0.25rem 0.5rem;\n    }\n    .programsList div {\n        font-size: 24px ;\n    }\n    .programDescription {\n        padding-top: 0.5em;\n        font-size: 12px;\n    }\n    .programPlan {\n        transform: translateY(-30px) translateX(20px);\n    }\n    .higherDoses {\n        font-size: 12px;\n    }\n    .programTitle {\n        font-size: 32px;\n    }\n    .programSubtext {\n        margin-top: 0.25rem;\n        font-size: 10px;\n    }\n    .semaDescription, .tirzDescription {\n        font-size: 14px;\n    }\n    .planPrice {\n        font-size: 36px;\n\n        span {\n            font-size: 24px;\n        }\n    }\n    .priceSubtext {\n        font-size: 12px;\n    }\n    .planName {\n        font-size: 14px;\n    }\n    .semaPlan, .tirzPlan {\n        font-size: 22px ;\n    }\n    .planButtonLeft, .planButtonRight {\n        display: flex;\n        position: absolute;\n        bottom: -22px;\n        width: 115px;\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n    .planButtonLeft {\n        margin-right: 0px;\n        padding-right: 0px;\n    }\n    .planButtonRight {\n        margin-left: 0px;\n        padding-left: 0px;\n    }\n    .orImg{\n        height: 110px;\n    }\n    .programsTitle {\n        padding-top: 0.5em;\n        font-size: 26px;\n    }\n    .semaPlan span, .tirzPlan span {\n        font-size: 16px ;\n    }\n    .programDivider {\n        width: 100%;\n        margin-left: 0;\n        margin-right: 0;\n        height: 10px;\n        border-radius: 0;\n    }\n    .buttonLabel {\n        font-size: 20px;\n    }\n    .goToMaintenance {\n        width: 90%;\n        font-size: 16px;\n    }\n}\n\n@media screen and (max-width: 878px) {\n    /* .program {\n        width: 80%;\n    } */\n    .bannerTitle {\n        font-size: 30px;\n    }\n    .bannerText h2 {\n        font-size: 51px;\n        margin: 0px 0px 20px;\n    }\n    .maintenancePlanBox {\n        min-width: 170px;\n    }\n    .programPlan {\n        min-width: 170px;\n        transform: translateY(-20px) translateX(0px);\n    }\n    .semaPlan, .tirzPlan, .semaMaintenancePlan, .tirzMaintenancePlan {\n        font-size: 22px;\n    }\n    .semaDescription, .tirzDescription, .semaMaintenanceDescription, .tirzMaintenanceDescription {\n        font-size: 10px;\n    }\n    .maintenancePlanPrice {\n        font-size: 40px;\n    }\n    .maintenancePlanName {\n        font-size: 16px;\n    }\n    .letsGo, .maintenanceLetsGo {\n        font-size: 18px;\n        padding: 7px;\n        gap: 0;\n    }\n}\n\n@media screen and (max-width: 800px) {\n    .programBanner {\n        margin-bottom: 0.5em;\n    }\n    .checkoutSelect {\n        font-size: 24px;\n    }\n    .programPlan {\n        min-width: 150px;\n        transform: translateY(0px) translateX(0px);\n    }\n    .programDescription {\n        font-size: 11px;\n    }\n    .programImage {\n        height: 140px;\n    }\n    .buttonArrow {\n        width: 15px;\n    }\n    .planPrice {\n        font-size: 28px;\n    }\n    .programsDivider {\n        margin-top: 20px;\n        margin-bottom: 20px;\n        height: 4px;\n    }\n    .orImg{\n        height: 100px;\n    }\n    .allPrograms {\n        padding-left: 5%;\n        padding-right: 5%;\n        padding-bottom: 5em;\n    }\n    .programsList div {\n        font-size: 20px;\n    }\n    .programsList img {\n        min-width: 15px;\n    }\n    .goToMaintenance {\n        font-size: 14px;\n    }\n}\n\n@media screen and (max-width: 740px) {\n    .program {\n        width: 90%;\n    }\n    .programPlan {\n        min-width: 200px;\n        transform: translateY(-10px) translateX(40px);\n    }\n    .programImage {\n        height: 130px;\n    }\n    .programSubtext {\n        font-size: 10px;\n    }\n}\n\n@media screen and (max-width: 518px) {\n    .programTitle {\n        font-size: 32px;\n        margin: 0;\n    }\n    .semaPlan, .tirzPlan {\n        padding-top: 0.25rem;\n    }\n    .programPlan {\n        min-width: 170px;\n        transform: translateY(-10px) translateX(40px);\n    }\n    .programSubtext {\n        margin-top: 0.25rem;\n    }\n    .planSubscription {\n        padding: 0.5rem;\n        min-width: 0;\n    }\n    .letsGo {\n        font-size: 16px;\n        padding: 8px;\n    }\n    .semaDescription, .tirzDescription {\n        font-size: 10px;\n    }\n    .programImage {\n        height: 150px;\n    }\n    .programDescription {\n        padding-left: 0.5em;\n        padding-top: 0.5em;\n    }\n    .programsList div {\n        font-size: 16px;\n    }\n    .programsList img {\n        min-width: 20px;\n    }\n    .allPrograms {\n        padding-left: 1em;\n        padding-right: 1em;\n    }\n    .goToMaintenance {\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width: 444px) {\n    .program {\n        width: 98%;\n    }\n    .programImage {\n        height: 120px;\n    }\n    .programPlan {\n        min-width: 150px;\n        transform: translateY(-10px) translateX(20px);\n    }\n    .programTitle {\n        font-size: 28px;\n    }\n    .programSubtext {\n        font-size: 10px;\n    }\n    .programDescription {\n        padding-top: 0.5em;\n        padding-bottom: 0.5em;\n        font-size: 10px;\n    }\n    .higherDoses {\n        font-size: 10px;\n    }\n    .planSubscription {\n        min-width: 0;    \n    }\n    .buttonLabel {\n        font-size: 16px;\n    }\n    .bannerSubtitle {\n        font-size: 12px;\n    }\n    .planPrice {\n        font-size: 20px;\n    }\n    .planName {\n        font-size: 12px;\n    }\n    .programsList div {\n        font-size: 14px;    \n    }\n    .programsList img {\n        min-width: 15px;\n    }\n}\n@media screen and (max-width: 378px) {\n    .programPlan {\n        transform: translateY(0px) translateX(10px);\n    }\n    .programsList {\n        margin-left: 0;\n        margin-right: 0;\n    }\n    .programsTitle {\n        font-size: 22px;\n    }\n    .goToMaintenance {\n        font-size: 10px;\n    }\n}\n@media screen and (max-width: 323px) {\n    .programTitle {\n        font-size: 24px;\n    }\n    .programBanner {\n        height: 100px;\n    }\n    .bannerTitle {\n        font-size: 24px;\n    }\n    .checkoutSelect {\n        font-size: 18px;\n        margin-bottom: 5px;\n    }\n    .programDivider {\n        height: 6px;\n    }\n    .programPlans {\n        width: 98%;\n    }\n    .semaPlan, .tirzPlan {\n        font-size: 18px;\n    }\n    .programPlan {\n        margin: 0.25em;\n        /* min-width: 0px; */\n        transform: translateY(00px) translateX(0px);\n    }\n    .buttonLabel {\n        font-size: 14px;\n    }\n    .programButtons button {\n        font-size: 12px;\n        height: 50px;\n    }\n    .letsGo {\n        font-size: 14px;\n        padding: 6px;\n    }\n    .buttonArrow {\n        width: 16px;\n    }\n    .programsTitle {\n        font-size: 20px;\n    }\n    .programsList div {\n        font-size: 12px;\n    }\n    .programsList img {\n        width: 12px;\n        min-width: 12px;\n    }\n    .journeyBtn2 {\n        font-size: 14px;\n    }\n    .journeyArrow {\n        width: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"programs": `Programs_programs__9GI-D`,
	"allPrograms": `Programs_allPrograms__ngATg`,
	"programsTitle": `Programs_programsTitle__5RnV6`,
	"programsDescription": `Programs_programsDescription__ebK0k`,
	"programsList": `Programs_programsList__-qr1w`,
	"program": `Programs_program__lN443`,
	"maintenanceProgram": `Programs_maintenanceProgram__o8NZK`,
	"programTitle": `Programs_programTitle__nWbCa`,
	"programImage": `Programs_programImage__hGRKZ`,
	"programText": `Programs_programText__XSiZR`,
	"programDescription": `Programs_programDescription__apssA`,
	"programsSubtext": `Programs_programsSubtext__CAXul`,
	"programSubtext": `Programs_programSubtext__Ek7YE`,
	"programPlans": `Programs_programPlans__n0Iup`,
	"maintenancePlans": `Programs_maintenancePlans__TdN18`,
	"programPlan": `Programs_programPlan__ov0ba`,
	"maintenancePlan": `Programs_maintenancePlan__qhNOL`,
	"maintenancePlanBox": `Programs_maintenancePlanBox__rS4qn`,
	"letsGo": `Programs_letsGo__cCoA3`,
	"maintenanceLetsGo": `Programs_maintenanceLetsGo__jnjyS`,
	"buttonArrow": `Programs_buttonArrow__1W1Gt`,
	"semaBackground": `Programs_semaBackground__W6iuy`,
	"tirzBackground": `Programs_tirzBackground__rRj2-`,
	"semaPlan": `Programs_semaPlan__MTq5b`,
	"semaMaintenancePlan": `Programs_semaMaintenancePlan__PkBuH`,
	"tirzPlan": `Programs_tirzPlan__1Og51`,
	"tirzMaintenancePlan": `Programs_tirzMaintenancePlan__1Zr4V`,
	"semaDescription": `Programs_semaDescription__DprWz`,
	"semaMaintenanceDescription": `Programs_semaMaintenanceDescription__6cwiX`,
	"tirzDescription": `Programs_tirzDescription__2GWDc`,
	"tirzMaintenanceDescription": `Programs_tirzMaintenanceDescription__hzxFU`,
	"semaglutidePlans": `Programs_semaglutidePlans__NKw3b`,
	"semaglutideMaintenancePlans": `Programs_semaglutideMaintenancePlans__dO8KU`,
	"tirzepatidePlans": `Programs_tirzepatidePlans__9Z6eX`,
	"tirzepatideMaintenancePlans": `Programs_tirzepatideMaintenancePlans__zIiS1`,
	"planButtonLeft": `Programs_planButtonLeft__Yw09Z`,
	"planButtonRight": `Programs_planButtonRight__0dzsz`,
	"planSubscription": `Programs_planSubscription__VG4Ni`,
	"planName": `Programs_planName__FAO+H`,
	"maintenancePlanName": `Programs_maintenancePlanName__k2w-+`,
	"planPrice": `Programs_planPrice__rC1b7`,
	"maintenancePlanPrice": `Programs_maintenancePlanPrice__9LrCT`,
	"priceSubtext": `Programs_priceSubtext__MxlVj`,
	"programBanner": `Programs_programBanner__fGffS`,
	"programDivider": `Programs_programDivider__LoFzj`,
	"programsDivider": `Programs_programsDivider__nxMcO`,
	"bannerText": `Programs_bannerText__5q+k-`,
	"bannerSubtitle": `Programs_bannerSubtitle__0kFn-`,
	"bannerTitle": `Programs_bannerTitle__gNFyP`,
	"goToMaintenance": `Programs_goToMaintenance__vGA4l`,
	"buttonLabel": `Programs_buttonLabel__D2zky`,
	"tirzHeading": `Programs_tirzHeading__TVTwk`,
	"semaHeading": `Programs_semaHeading__OgWzs`,
	"programButtons": `Programs_programButtons__1pumR`,
	"journeyBtn2": `Programs_journeyBtn2__Wy6+h`,
	"journeyArrow": `Programs_journeyArrow__-29XB`,
	"orImg": `Programs_orImg__ZSwyR`,
	"programBorder": `Programs_programBorder__abxYT`,
	"responsiveProgram": `Programs_responsiveProgram__CORoS`,
	"checkmark": `Programs_checkmark__4gvef`,
	"splitter": `Programs_splitter__0Gh2I`,
	"programPanel": `Programs_programPanel__qWlRd`,
	"checkoutSelect": `Programs_checkoutSelect__AO3NS`,
	"glowGreen": `Programs_glowGreen__InM8B`,
	"glowBlue": `Programs_glowBlue__vPXaO`,
	"higherDoses": `Programs_higherDoses__IUCxU`,
	"boderline": `Programs_boderline__X8Oe1`
};
export default ___CSS_LOADER_EXPORT___;
